import { useEffect, useState } from 'react';
import { loadInlineImage } from '../utils/cardExport';

interface InlineImageState {
  /** Data URL, or null when there is no image or it could not be loaded. */
  src: string | null;
  settled: boolean;
}

export function useInlineImage(src?: string): InlineImageState {
  const [result, setResult] = useState<{ for: string; value: string | null } | null>(null);

  useEffect(() => {
    if (!src) return;
    let active = true;
    void loadInlineImage(src).then((value) => {
      if (active) setResult({ for: src, value });
    });
    return () => {
      active = false;
    };
  }, [src]);

  if (!src) return { src: null, settled: true };
  if (result?.for !== src) return { src: null, settled: false };
  return { src: result.value, settled: true };
}
